
export default function encript(mystring) {
    const last4 = mystring.slice(-4)
    const initial = mystring.slice(0,-4)
    const codec = Buffer.from(last4+initial).toString('base64')
  return codec
}
